import 'src/css/aiassistant.css';
import { withTranslation } from "react-i18next";
import { Col, Row, Placeholder } from 'react-bootstrap';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';

class LoadingMessage extends Component {
    render() {
        return (
            <Row className='aimessage'>
                <Row>
                    <Col>
                        <div className='aiicon'>
                            <FontAwesomeIcon className='text-primary' size='xl' icon={duotone('microchip-ai')} bounce />
                            <span className='text-gray-800'>{this.props.t("pleasewait")}</span>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Placeholder as="p" animation="glow">
                            <Placeholder xs={12} />
                        </Placeholder>
                        <Placeholder as="p" animation="glow">
                            <Placeholder xs={8} />
                        </Placeholder>
                    </Col>
                </Row>
            </Row>);
    }
}


const mapStateToProps = (state) => {
    return {
        photo: state.agent.photo,
        initials: state.agent.initials,
    };
};

function WithNavigate(props) {
    let navigate = useNavigate();
    return <LoadingMessage {...props} navigate={navigate} />
}

export default compose(connect(mapStateToProps, {}), withTranslation())(WithNavigate);